export const MOVE_APPOINTMENT = 'MOVE_APPOINTMENT';
export const MOVE_ROOM = 'MOVE_ROOM';
export const MOVE_EQUIPMENT = 'MOVE_EQUIPMENT';
export const MOVE_RESCHEDULE_APPOINTMENT = 'MOVE_RESCHEDULE_APPOINTMENT';
export const MOVE_APPOINTMENT_STAFF_WEEK_VIEW = 'MOVE_APPOINTMENT_STAFF_WEEK_VIEW';
export const MOVE_REORDER_PRACTITIONER = 'MOVE_REORDER_PRACTITIONER';
export const MOVE_UNIT = 'MOVE_UNIT';
